module.exports = "/_next/static/images/e5a0a8840b1e8dcc6ba4309770676a3f-bubble-gum-woman-square@lg-2x.jpg";